import { removeFilter, addFilter } from '@wordpress/hooks';
import { TextControl, PanelRow } from '@wordpress/components'
import { dispatch, useSelect } from '@wordpress/data'
import { __ } from '@wordpress/i18n'

const TripCode = ({allData}) => {
    const { updateTripData } = dispatch('WPTravel/TripEdit')
    const { wp_travel_trip_code: tripCode } = allData.utilities || ''

    const settings = useSelect((select) => {
        return select('WPTravel/TripEdit').getSettings()
    }, []);
    let disableTripCode = settings && settings.enable_custom_trip_code_option == 'yes' ? false : true
    return <PanelRow>
        <label>{__('Trip code', 'wp-travel-pro')}</label>
        <TextControl
            disabled={disableTripCode}
            value={tripCode}
            onChange={value => updateTripData({ ...allData, utilities: { ...allData.utilities, wp_travel_trip_code: value } })}
        />
    </PanelRow>
}

const TripCodeCB = ( content, allData ) => {
    return [ ...content, <TripCode allData={allData} /> ];
}

// Remove Fields.
removeFilter( 'wptravel_trip_edit_tab_content_itinerary', 'WPTravel/TripEdit/TripCode' );
removeFilter( 'wp_travel_trip_edit_block_trip_code_inspector_controls', 'WPTravel/TripEdit/Block/TripCode/Notice' );
// Add Fields.
addFilter( 'wptravel_trip_edit_tab_content_itinerary', 'WPTravelPro/TripEdit/TripCode', TripCodeCB, 10 );
addFilter( 'wp_travel_trip_edit_block_trip_code_inspector_controls', 'WPTravelBlocks/TripEdit/TripCode', TripCodeCB, 10 );
